"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reduxPersist = require("redux-persist");

var _session = _interopRequireDefault(require("redux-persist/lib/storage/session"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _App = _interopRequireDefault(require("./containers/App"));

var _TranslationContext = require("./context/TranslationContext");

var _searchReducer = _interopRequireDefault(require("./reducers/searchReducer"));

var _sagas = _interopRequireDefault(require("./sagas"));

var _config = _interopRequireDefault(require("./config.json"));

var _appConstants = require("./constants/appConstants");

var _styledComponents = require("styled-components");

var _r10SourceLibrary = require("r10-source-library");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerSearch = function CustomerSearch(_ref) {
  var i18n = _ref.i18n,
      language = _ref.language,
      __instanceId = _ref.__instanceId;
  __instanceId = __instanceId.split('_').join('-');
  var config = (0, _reactRedux.useSelector)(function (state) {
    return state.config.data && state.config.data.widgets[_appConstants.pkgName][__instanceId] ? state.config.data.widgets[_appConstants.pkgName][__instanceId] : _config.default;
  });
  var t = i18n ? function (key) {
    var tr = i18n(key);
    return tr || key;
  } : function (key) {
    return key;
  };
  if (!language || !config) return null;
  return /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
    theme: _r10SourceLibrary.themeWS10
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.themeWS10.globalStyles, null), /*#__PURE__*/_react.default.createElement(_TranslationContext.TranslationProvider, {
    t: t
  }, /*#__PURE__*/_react.default.createElement(_App.default, {
    instanceId: __instanceId,
    config: config
  })));
};

CustomerSearch.propTypes = {
  i18n: _propTypes.default.func,
  language: _propTypes.default.string,
  __instanceId: _propTypes.default.string
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var language = _ref2.language.language;
  return {
    language: language
  };
};

var exported = (0, _reactRedux.connect)(mapStateToProps)(CustomerSearch);
var persistConfig = {
  key: _appConstants.pkgName,
  storage: _session.default,
  blacklist: ['error']
};
var _default = exported;
exports.default = _default;
exported.reducer = (0, _reduxPersist.persistReducer)(persistConfig, _searchReducer.default);
exported.sagas = _sagas.default;

var logger = function logger(store) {
  return function (next) {
    return function (action) {
      console.log('dispatching', action);
      var result = next(action);
      console.log('next state', store.getState());
      return result;
    };
  };
};

exported.middlewares = [logger];